import { ILookupApiResponse, INegotiatingTactic, IRegion, ISalesDistrict, ISourceOfPower } from '../lookups';
import { SalesAdminActionKeys as keys } from './salesAdminActionKeys';
import { AdminSalesEndpoints } from './salesAdminApi';
import { ISalesDistrictDealerGoal, SalesAdminLoadingTypes } from './salesAdminInterfaces';

export const salesAdminActionCreators = {
  deleteObject: (payload: ISalesAdminDeleteObject) =>
    ({
      payload,
      type: keys.DELETE_SALES_ADMIN_OBJECT
    } as const),
  fetchSalesDistrictGoals: (fiscalYear: string) =>
    ({ payload: { fiscalYear }, type: keys.FETCH_SALES_DISTRICT_GOALS } as const),
  fetchSalesDistricts: () =>
    ({
      type: keys.FETCH_SA_SALES_DISTS
    } as const),
  removeSalesDistrictGoal: (payload: ISalesDistrictDealerGoal) =>
    ({ payload, type: keys.REMOVE_SALES_DISTRICT_GOAL } as const),
  saveNegotiatingTactic: (payload: INegotiatingTactic) =>
    ({
      payload,
      type: keys.SAVE_NEGOTIATING_TACTIC
    } as const),
  saveRegion: (payload: IRegion) => ({ payload, type: keys.SAVE_SA_REGION } as const),
  saveSalesDistrict: (payload: ISalesDistrict) =>
    ({
      payload,
      type: keys.SAVE_SA_SALES_DISTS
    } as const),
  saveSalesDistrictGoal: (payload: { old: ISalesDistrictDealerGoal; new: ISalesDistrictDealerGoal }) =>
    ({ payload, type: keys.SAVE_SALES_DISTRICT_GOAL } as const),
  saveSourceOfPower: (payload: ISourceOfPower) =>
    ({
      payload,
      type: keys.SAVE_SOURCE_OF_POWER
    } as const),
  setSalesDistrictGoals: (payload: ISalesDistrictDealerGoal[]) =>
    ({
      payload,
      type: keys.SET_SALES_DISTRICT_GOALS
    } as const),
  setSalesDistricts: (payload: ISalesDistrict[]) =>
    ({
      payload,
      type: keys.SET_SA_SALES_DISTS
    } as const),
  toggleLoading: (type: SalesAdminLoadingTypes) =>
    ({
      payload: type,
      type: keys.TOGGLE_SA_LOADING
    } as const),
  updateObject: (payload: ISalesAdminUpdateObject) =>
    ({
      payload,
      type: keys.UPDATE_SALES_ADMIN_OBJECT
    } as const)
} as const;

interface ISalesAdminUpdateObject<T extends object = {}> {
  endpoint: AdminSalesEndpoints;
  value: T;
  type: keyof ILookupApiResponse;
}

interface ISalesAdminDeleteObject {
  endpoint: AdminSalesEndpoints;
  id: number;
  type: keyof ILookupApiResponse;
}
